import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import CsInformationModal from "../../models/CsInformationModal.js";

const InformationComponent = (props) => {
  const { csInformation } = props;
  let csDiagnosticsObj = new CsInformationModal(csInformation).toStateJson();
  delete csDiagnosticsObj.errors;

  const beautifyText = (text) => {
    return text.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  return <Fragment>
    <div className="border border-success border-1 rounded-2 border-opacity-25 p-2" style={{ height: '190px', overflow: 'hidden', backgroundColor: '#ecf2ea' }}>
      <h6 className="text-success text-center">INFORMATION</h6>
      <div className="custom-scrollbar border" style={{ height: '85%', overflowY: 'auto' }}>
        <table className="table table-sm" style={{ margin: '0' }}>
          <thead style={{ position: 'sticky', top: '0' }}>
            <tr>
              {/* <th className="bg-success-subtle bg-gradient" scope="col">Attribute</th>
              <th className="bg-success-subtle bg-gradient" scope="col">Details</th>
              <th className="bg-success-subtle bg-gradient" scope="col">Attribute</th>
              <th className="bg-success-subtle bg-gradient" scope="col">Details</th> */}
            </tr>
          </thead>
          <tbody>
            {Object.keys(csDiagnosticsObj).length > 0 ?
              Object.keys(csDiagnosticsObj).map((key) => {
                if(key === 'latitude' || key === 'longitude'){
                  if(key === 'longitude'){
                    return <tr key={key}>
                      <td rowSpan={2} style={{ minWidth: '200px' }} className="border fw-medium bg-light">Latitude Longitude</td>
                      <td rowSpan={2} style={{ minWidth: '200px' }} className="border">
                        <a 
                          href={`https://www.google.com/maps?q=${csDiagnosticsObj.latitude},${csDiagnosticsObj.longitude}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-success"
                          style={{height: '12px'}}
                        >
                          <FontAwesomeIcon icon={faLocationDot} className="me-2"/>
                          {csDiagnosticsObj['latitude']}, {csDiagnosticsObj['longitude']}
                        </a>
                      </td>
                    </tr>
                  } else {
                    return <tr key={key}></tr>
                  }
                } else {
                  return <tr key={key}>
                    <td rowSpan={2} style={{ minWidth: '200px' }} className="border fw-medium bg-light">{beautifyText(key)}</td>
                    <td rowSpan={2} style={{ minWidth: '200px' }} className="border">{csDiagnosticsObj[key]}</td>
                  </tr>
                }
              }) :
              (
                <tr>
                  <td colSpan={4} className="text-center bg-light">No matching records found</td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </div>
  </Fragment>
}

export default InformationComponent;
